import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m5.651 23.5 12.576-11.126a.5.5 0 0 0 0-.748L5.651.5" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { toRefs } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    size: { default: 12 }
  },
  setup(__props: any) {

const props = __props as { size: number }

    

    const { size } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: _unref(size),
    height: _unref(size),
    viewBox: "0 0 24 24",
    fill: "none",
    "stroke-width": "2",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, _hoisted_3, 8, _hoisted_1))
}
}

})